module.exports = __webpack_public_path__ + "988a2810b775cb399802b231c6b06eba.gif";